import { createSelector } from 'reselect';
import { favoriteComponentsSelector } from 'app/UserInfo/selectors';

import canEditGivenComponentSelector from './canEditGivenComponent';

export default state => {
  const selector = createSelector(favoriteComponentsSelector, components =>
    components.map(component => ({
      ...component,
      isReadonly: !canEditGivenComponentSelector(component, state)
    }))
  );
  return selector(state);
};
